import { lighten, Theme } from "@mui/material";
import MuiRadio, { RadioProps } from "@mui/material/Radio";
import { COLORS } from "../../../../constants/colors";

const radioSxProps = {
  color: "rgba(0,0,0,.5)",
  "&:hover": {
    backgroundColor: "rgba(0,0,0,.04)",
  },
  "&:focus": {
    border: `1px solid ${COLORS.S_HIGH_EMPHASIS}`,
  },
  "&.Mui-disabled": {
    color: "rgba(0,0,0,.1)",
    "&.Mui-checked": {
      color: (theme: Theme) => lighten(theme.palette.primary.main, 0.62), //.38
    },
  },
  "&.Mui-checked": {
    color: "primary.main",
    "&:hover": {
      backgroundColor: (theme: Theme) =>
        lighten(theme.palette.primary.main, 0.96), //.04
    },
    "&:focus": {
      border: (theme: Theme) => `1px solid ${theme.palette.primary.main}`,
    },
  },
};

const RadioButton = ({
  color = "default", // MuiRadio defaults to "secondary" otherwise
  checked,
  ...rest
}: RadioProps): JSX.Element => {
  return (
    <MuiRadio sx={radioSxProps} checked={checked} color={color} {...rest} />
  );
};

export default RadioButton;
